import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { DatePicker, Flex, Input, Select, TimePicker, Typography } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getClubs, getTrainers } from 'src/store/Slices/DropDownSlice';
import { slotsAction } from 'src/store/Slices/Administrator/SlotsSlice';
import { getServices } from 'src/store/Slices/AbonementsSlice';

const AddEditSlotsModal = ({ visible, setVisible, slotsInfo, setPage, setPageSize }) => {

    const dispatch = useDispatch()

    const [date, setDate] = useState()
    const [time, setTime] = useState()
    const [service, setService] = useState()
    const [club, setClub] = useState()
    const [trainer, setTrainer] = useState()

    const clubs = useSelector(state => state.DropDownSlice.clubs)
    const abonementServices = useSelector(state => state.AbonementsSlice.abonementServices)
    const trainersList = useSelector(state => state.DropDownSlice.trainersList)


    useEffect(() => {
        setDate()
        setTime()
        setService()
        setClub()
        setTrainer()
    }, [visible.flag])


    useEffect(() => {
        if (visible.flag === 'edit') {
            setClub(clubs?.data?.value.find(el => el.label === slotsInfo?.clubName)?.value)
            setService(abonementServices?.data?.value.find(el => el.label === slotsInfo?.serviceName)?.value)
            setTrainer(trainersList?.data?.value.find(el => el.label === slotsInfo?.employName)?.value)
        }
    }, [visible, slotsInfo, clubs, trainersList, abonementServices])

    useEffect(() => {
        if (visible.flag === 'edit') {
            dispatch(getClubs())
            dispatch(getTrainers())
            dispatch(getServices())
        }
    }, [visible])

    const onClickSubmit = () => {
        dispatch(slotsAction({
            flag: visible.flag === 'add' ? 'put' : 'post', value: {
                id: visible.flag !== 'add' ? slotsInfo.id : undefined,
                dateTime : date,
                serviceId: service,
                employId: trainer,
                clubId: club
            }
        })).then(() => {
            dispatch(slotsAction({ flag: 'get' })).then(() => {
                setVisible({ open: false, flag: '' })
                setPage(1)
                setPageSize(20)
            })
        })
    }


    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить временный слот' : 'Редактировать временный слот'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Дата</Typography.Title>
                            <DatePicker
                                value={date}
                                onChange={e => setDate(e)}
                                style={{ width: '100%' }}
                                showTime
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Услуга</Typography.Title>
                            <Select
                                value={service}
                                onChange={e => setService(e)}
                                onClick={() => { visible.flag === 'add' && dispatch(getServices()) }}
                                style={{ width: '100%' }}
                                options={abonementServices?.data?.value}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Клуб</Typography.Title>
                            <Select
                                placeholder='Выбрать'
                                style={{ width: '100%' }}
                                value={club}
                                onChange={e => setClub(e)}
                                onClick={() => { visible.flag === 'add' && dispatch(getClubs()) }}
                                options={clubs?.data?.value}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Тренер</Typography.Title>
                            <Select
                                placeholder='Выбрать'
                                style={{ width: '100%' }}
                                value={trainer}
                                onChange={e => setTrainer(e)}
                                onClick={() => { visible.flag === 'add' && dispatch(getTrainers()) }}
                                options={trainersList?.data?.value}
                            />
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditSlotsModal